// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + {"81":"ReviewOrder","113":"PaymentForm","238":"checkoutPage","556":"CheckoutSuccess","818":"materialLayout","928":"AddressForm"}[chunkId] + ".js";
};